import { useState, useEffect } from 'react';

const palettes = {
  white: {
    panelBg: '#ffffff',
    panelBorder: '#ccc',
    buttonBg: '#f5f5f5',
    buttonBgActive: '#bbdefb',
    buttonBgToggleOn: '#bbdefb',
    buttonBgToggleOff: '#f5f5f5',
    buttonBgSelected: '#c8e6c9',
    buttonBgDisabled: '#e0e0e0',
    buttonHover: '#e0e0e0',
    buttonHoverActive: '#90caf9',
    buttonHoverDisabled: '#e0e0e0',
    headerBg: '#e3f2fd',
    headerHover: '#bbdefb',
    text: '#333',
    textDisabled: '#999',
  },
  default: {
    panelBg: '#fff',
    panelBorder: '#ccc',
    buttonBg: '#f5f5f5',
    buttonBgActive: '#bbdefb',
    buttonBgToggleOn: '#bbdefb',
    buttonBgToggleOff: '#f5f5f5',
    buttonBgSelected: '#c8e6c9',
    buttonBgDisabled: '#e0e0e0',
    buttonHover: '#e0e0e0',
    buttonHoverActive: '#90caf9',
    buttonHoverDisabled: '#e0e0e0',
    headerBg: '#e3f2fd',
    headerHover: '#bbdefb',
    text: '#333',
    textDisabled: '#999',
  },
  dark: {
    panelBg: '#ddeadd',
    panelBorder: '#a8c8a8',
    buttonBg: '#ccdece',
    buttonBgActive: '#a8c8a8',
    buttonBgToggleOn: '#a8c8a8',
    buttonBgToggleOff: '#ccdece',
    buttonBgSelected: '#b8d8b8',
    buttonBgDisabled: '#eef2ee',
    buttonHover: '#c0d8c0',
    buttonHoverActive: '#98b898',
    buttonHoverDisabled: '#eef2ee',
    headerBg: '#d4e4d4',
    headerHover: '#c0d8c0',
    text: '#2d3d2d',
    textDisabled: '#7a9a7a',
  },
  warm: {
    panelBg: '#fff8f0',
    panelBorder: '#c9a87c',
    buttonBg: '#fff8f0',
    buttonBgActive: '#f8dfc0',
    buttonBgToggleOn: '#f8dfc0',
    buttonBgToggleOff: '#fff8f0',
    buttonBgSelected: '#d4edda',
    buttonBgDisabled: '#f5ede0',
    buttonHover: '#fdefd8',
    buttonHoverActive: '#f0c890',
    buttonHoverDisabled: '#f5ede0',
    headerBg: '#f5ede0',
    headerHover: '#fdefd8',
    text: '#5c3d1e',
    textDisabled: '#a08060',
  },
};

export function useThemeColors() {
  const getTheme = () => document.body.getAttribute('data-theme') || 'default';
  const [colors, setColors] = useState(() => palettes[getTheme()] || palettes.default);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const t = getTheme();
      setColors(palettes[t] || palettes.default);
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return colors;
}
